import { render, staticRenderFns } from "./ProductTitle.vue?vue&type=template&id=0291bdd3&scoped=true&functional=true"
import script from "./ProductTitle.vue?vue&type=script&lang=js"
export * from "./ProductTitle.vue?vue&type=script&lang=js"
import style0 from "./ProductTitle.vue?vue&type=style&index=0&id=0291bdd3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0291bdd3",
  null
  
)

export default component.exports